import Button from "@/lib/Button";
import TimelineItem from "./TimelineItem";
import useModal from "@/lib/modal/useModal";
import AddNote from "./AddNote";
import useGetCurrentQuoteRevision from "@/lib/SelectedQuoteRevisionIdContext/useGetCurrentQuoteRevision";
import Card from "@/lib/Card";
import $api from "@/lib/queries/openapi";
import { useParams } from "react-router";

export default function Timeline() {
  const { showModal, closeModal } = useModal();
  const { rfqId, teamSlug } = useParams();

  const { data: timeline = [] } = $api.useQuery(
    "get",
    "/api/teams/{team_slug}/rfqs/{id}/timeline",
    {
      params: {
        path: {
          team_slug: teamSlug!,
          id: rfqId!,
        },
      },
    },
  );
  const canEditQuoteRevision = useGetCurrentQuoteRevision()?.can_edit;

  return (
    <Card
      header={
        <div className="flex items-center justify-between">
          <div className="font-bold text-lg">Timeline</div>
          {canEditQuoteRevision && (
            <Button
              onClick={() => showModal(<AddNote done={closeModal} />)}
              secondary
              size="sm"
            >
              Add Note
            </Button>
          )}
        </div>
      }
    >
      {timeline.map((t) => (
        <TimelineItem data={t} key={t.event_time} />
      ))}
    </Card>
  );
}
